"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "useScrollbarSize", {
  enumerable: true,
  get: function () {
    return _useScrollbarSize.useScrollbarSize;
  }
});
var _useScrollbarSize = require("./useScrollbarSize");
/* eslint-disable import/no-default-export */
var _default = _useScrollbarSize.useScrollbarSize;
exports.default = _default;